import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useAuthStore } from '@/stores/authStore';

import 'bootstrap'; // Hier importieren wir das Bootstrap JavaScript

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faArrowRightFromBracket,
  faBuilding,
  faCheck,
  faChevronLeft,
  faCircleCheck,
  faCircleInfo,
  faCodeMerge,
  faDisplay,
  faFileImport,
  faHouse,
  faList,
  faPen,
  faPlus,
  faRotate,
  faTrash,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAddressCard,
  faArrowRightFromBracket,

  faBuilding,

  faCheck,
  faChevronLeft,
  faCircleCheck,
  faCircleInfo,
  faCodeMerge,

  faDisplay,

  faFileImport,

  faHouse,

  faList,

  faPen,
  faPlus,

  faRotate,

  faTrash,

  faUsers,

  faXmark
);

// import keycloak from './keycloak';

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    auth.login();
  }

  app.mount('#app');
}

bootstrap();
